<ng-container *transloco="let t">
  <div class="position-relative">
    <div class="x-button-wrapper">
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      </button>
    </div>
    <div class="d-flex justify-content-center pt-48-38">
      <span class="fs-44-32 fw-semibold text-center title-wrapper line-height-1">
        {{ title }}
      </span>
    </div>
    <div class="organiser-content-wrapper">
      @if (!requestSent) {
      <form [formGroup]="inputForm" class="w-100">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="pt-20-10">
              <app-input formControlName="name" label="organiser.details.name" />
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="pt-20-10">
              <app-input formControlName="fullName" label="organiser.details.full.name" />
            </div>
          </div>
        </div>
        <div class="pt-20-10">
          <app-input formControlName="website" label="organiser.details.web" />
        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="pt-20-10">
              <app-input formControlName="email" label="organiser.details.email" />
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="pt-20-10">
              <app-tel-input [formControlName]="'phone'" [label]="t('organiser.details.phone')"
                [numberPlaceholder]="t('organiser.details.phone')" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="pt-20-10">
              <app-input formControlName="address" label="organiser.details.address" />
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="pt-20-10">
              <app-input formControlName="place" label="organiser.details.place" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="pt-20-10">
              <app-input formControlName="zip" label="app.common.zip" />
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="pt-20-10">
              <app-select formControlName="country" [hasDefault]="true" [items]="countries" [valueKey]="'id'"
                [labelKey]="'name'" label="app.common.country" />
            </div>
          </div>
        </div>
      </form>
      } @else {<span>
        {{ t("request.modal.sent") }}
      </span>
      }
      <div class="d-flex align-items-center justify-content-end pt-5 w-100">
        <div class="pe-3">
          <app-rounded-button [label]="t('app.common.cancel')" [btnClass]="'rounded-button--button-black-solid'"
            (onClick)="onDismissClick()" />
        </div>
        <div>
          @if (!requestSent) {
          <app-rounded-button [label]="t('app.common.confirm')" (onClick)="onConfirmClick()" />
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>